<template>
    <div class="pad:-mx-5 pad:-my-1 md:m-0">
        <h3 class="text-center pt-5 pad:pt-8 mt-0 mb-5 pad:mb-10">
            請選擇欲申請之類別
        </h3>
        <div
            v-if="btnText"
            class="mx-auto max-w-[24.375rem] mb-12 pad:max-w-full pad:flex pad:justify-center pad:relative"
        >
            <!-- collapse -->
            <div
                v-for="(btn, index) in btnText"
                v-show="isDevMode() ? btn : !btn.onlyDev"
                :key="index"
                class="mb-4 pad:mb-0 pad:mr-4 lg:mr-7 last:mr-0"
            >
                <!-- collapse-title -->
                <button
                    class="btn home-collapse-title-btn ring-1 ring-gray-200 ring-inset cursor-pointer pad:mb-8 "
                    :class="isActive(index)? 'gradient-primary pad:-translate-y-2.5': 'text-black lg:hover:ring lg:hover:ring-primary lg:hover:bg-white'"
                    @click="clickBtn(index, btn)"
                >
                    <div class="hidden pad:block pad:mr-2.5">
                        <SvgIcon
                            :icon-name="isActive(index) ?btn.iconActive :btn.icon"
                            class="w-[4.5rem] h-[4.5rem]"
                        />
                    </div>
                    {{ btn.title }}
                    <div
                        v-show="isActive(index)"
                        class="btnArrow hidden pad:block"
                    />
                </button>
                <!-- collapse-content -->
                <div
                    v-if="isActive(index)"
                    class="home-collapse-content"
                    :class="{'pad:justify-center': currentIndex === 1,'pad:justify-end': currentIndex === 2}"
                >
                    <button
                        v-for="(subBtn, i) in btn.subBtn"
                        v-show="isDevMode() ? subBtn : !subBtn.onlyDev"
                        :key="i"
                        class="btn home-content-btn  pad:mr-4 last:pad:mr-0"
                        :class="[subBtn.class ? subBtn.class:'pad:w-40 lg:w-[11.25rem]']"
                        @click.stop="goNextPage(subBtn)"
                    >
                        {{ subBtn.title }}
                    </button>
                </div>
                <div
                    class="md-collapse-layer"
                    :class="{'pad:mt-12 ': isActive(index)}"
                />
            </div>
        </div>

        <div class="sm:px-5 pad:p-0">
            <TermsHome />
        </div>
        <!-- modal -->
        <label
            v-show="!visibleModal && noticeList.length>0"
            class="modal-button"
            @click="visibleModal = true"
        >
            <SvgIcon
                icon-name="message-alert"
                class="w-6 h-6 text-white"
            />
        </label>
        <Modal
            v-model:visibleModal="visibleModal"
            :notice-list="noticeList"
        />
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { initTransaction } from '@/apis/system';
import routeName from '@/router/constant.js';
import Modal from './modal.vue';
import TermsHome from '@/components/termContent/TermsHome.vue';
import Loading from '@/components/Loading.vue';
import { isDevMode } from '@/utils/is';
import { getNoticeInfo, getPauseFunctionInfo } from '@/apis/notice';
import serviceRoutes from '@/json/serviceRoutes.js';
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const btnTextArr = [
    {
        title: '保單借款',
        icon: 'policy-loan',
        iconActive: 'policy-loan-white',
        routerName: routeName.LOAN_TERM_ONE,
        code: codeList.PON4300,
        aplCatl: aplCatlCode.PON4300,
        onlyDev: false,
    },
    {
        title: '保單變更',
        icon: 'policy-change',
        iconActive: 'policy-change-white',
        onlyDev: false,
        subBtn: [
            {
                title: '要保人聯絡資訊',
                routerName: routeName.CONTACT_INFO,
                code: 'BD',
                aplCatl: aplCatlCode.CONTACT,
                onlyDev: false
            },
            {
                title: '申請電子通知單',
                routerName: routeName.EDIT_TEL_MAIL,
                code: 'multiENotify',
                aplCatl: aplCatlCode.MULTI_ENOTIFY,
                onlyDev: false
            },
            {
                title: '傳統型保單',
                routerName: routeName.POLICY_BASIC,
                aplCatl: aplCatlCode.POLICY,
                onlyDev: false
            },
            {
                title: '投資型保單',
                routerName: routeName.POLICY_INVESTMENT,
                aplCatl: aplCatlCode.POLICY,
                onlyDev: false
            }]
    },
    {
        title: '繳費方式變更',
        icon: 'payment-change',
        iconActive: 'payment-change-white',
        onlyDev: false,
        buttonNo: 'show7', // 為了選到
        subBtn: [
            {
                title: '申請金融機構轉帳電子化繳費授權',
                routerName: routeName.AUTH_METHODS,
                aplCatl: aplCatlCode.ACH,
                code: codeList.ACH,
                class: 'col-span-2 pad:w-[18.75rem]',
                onlyDev: false,
            },
            {
                title: '申請自行繳費',
                routerName: routeName.EDIT_TEL_MAIL,
                aplCatl: aplCatlCode.MULTI_PAY_CHANGE,
                code: codeList.MULTI_PAY_CHANGE,
                onlyDev: false,
            },
            {
                title: '申請信用卡授權',
                routerName: routeName.EDIT_TEL_MAIL,
                aplCatl: aplCatlCode.CREDIT_CARD_AUTH,
                code: codeList.CREDIT_CARD_AUTH,
                onlyDev: false,
            },
            {
                title: '信用卡效期延長',
                routerName: routeName.EDIT_TEL_MAIL,
                aplCatl: aplCatlCode.CREDIT_CARD_EXP,
                code: codeList.CREDIT_CARD_EXP,
                onlyDev: false,
            }]
    },
    {
        title: 'LINE通知訊息',
        icon: 'message',
        iconActive: 'policy-loan-white',
        routerName: routeName.LINEPNP,
        code: codeList.LINEPNP,
        aplCatl: aplCatlCode.LINEPNP,
        onlyDev: false,
    },
];

export default {
    name: 'Home',
    components: {
        TermsHome,
        Modal,
        Loading
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const btnText = ref([]);
        const visiblePopup = ref(false);
        const visibleModal = ref(false);
        const currentIndex = ref(null);
        const isLoading = ref(false);
        const loadingCount = ref(0);
        const noticeList = ref([]);

        const isActive = computed(() => {
            return (index) => {
                return currentIndex.value === index && index !== 0;
            };
        });

        const activeBtn = (index) => {
            currentIndex.value = currentIndex.value === index ? null : index;
        };

        const clickBtn = (index, btn) => {
            if (index === 0) {
                goNextPage(btn);
            } else if (index === 3) {
                goNextPage2();
                // router.push({ name: routeName.LOAN_TERM_ONE });
                // router.push({ name: routeName.LOAN_TERM_ONE }).catch(err => { console.log(err); });
                // router.push({ name: routeName.LINEPNP });
                // setTimeout(() => {
                //    window.location = `${process.env.VUE_APP_CONTEXT_PATH}/line-forward`;
                // }, 500);
            } else {
                activeBtn(index);
            }
        };

        const getData = () => {
            loadingCount.value = 2;
            getNoticeInfo().then(res => {
                noticeList.value = res.data.noticeList;
                if (noticeList.value.length > 0) {
                    visibleModal.value = true;
                }
            }).finally(() => {
                loadingCount.value--;
            });
            getPauseFunctionInfo().then((res) => {
                if (res.data.pauseFunctionInfoList.length > 0) {
                    const aplCatlLiat = res.data.pauseFunctionInfoList.map(i => i.aplCatl);
                    btnText.value = [];
                    btnTextArr.forEach(i => {
                        if (i.subBtn?.length > 0) {
                            i.subBtn = i.subBtn.filter((item, index) => {
                                const obj = aplCatlLiat.find(f => item.aplCatl === f);
                                if (!obj) return item;
                            });
                        }
                        if (!i.aplCatl || !(aplCatlLiat.find(f => i.aplCatl === f))) {
                            btnText.value.push(i);
                        }
                    });
                } else {
                    btnText.value = btnTextArr;
                }
            }).finally(() => {
                loadingCount.value--;
            });
        };
        getData();

        onMounted(() => {
            if (route.params.action) {
                btnText.value.forEach((item, index) => {
                    if (route.params.action === item.buttonNo) {
                        activeBtn(index);
                    }
                });
            }
        });

        const goNextPage2 = () => {
            loadingCount.value = 1;
            try {
                // router.push({ name: routeName.LINEPNP });
                setTimeout(() => {
                    window.location = `${process.env.VUE_APP_CONTEXT_PATH}/line-forward`;
                }, 500);
            } catch (e) {
                loadingCount.value = 0;
                console.log('home:', e);
            }
        };

        const goNextPage = (btn) => {
            loadingCount.value = 1;
            const { routerName, aplCatl, code } = btn;
            try {
                // if (aplCatl !== aplCatlCode.ACH) {
                initTransaction(aplCatl).then((res) => {
                    store.dispatch('services/setAplCatl', aplCatl);
                    store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
                    if (aplCatl !== aplCatlCode.POLICY) {
                        const index = serviceRoutes.findIndex(i => i.code === code);
                        const data = [{
                            transactionItemName: btn.title,
                            userChecked: true,
                            transactionItemNo: code,
                            routeName: serviceRoutes[index].routeName
                        }];
                        // for step route
                        store.dispatch('services/setServices', data);
                        // for 資料確認頁面
                        store.dispatch('services/setTransactionItems', data);
                    }
                    router.push({ name: routerName }).catch(err => { console.log(err); });
                }).catch(() => {
                    loadingCount.value = 0;
                });
            } catch (e) {
                loadingCount.value = 0;
                console.log('home:', e);
            }
        };
        watch(() => loadingCount.value, (nV, oV) => {
            isLoading.value = nV > 0;
        });
        return {
            visiblePopup,
            visibleModal,
            btnText,
            currentIndex,
            activeBtn,
            goNextPage,
            goNextPage2,
            isActive,
            isLoading,
            noticeList,
            isDevMode,
            clickBtn,
        };
    },
};
</script>

<style scoped>
.home-collapse-title-btn {
    @apply bg-white text-base xs:text-lg pad:text-xl h-[3.75rem] pad:h-[8.25rem] w-full pad:w-60 lg:w-[15.9375rem] no-animation rounded-md shadow-3  border-0;
}

.home-collapse-content {
    @apply px-2.5 pt-4 pb-2.5 grid grid-cols-2 gap-2.5 pad:p-0 pad:grid-cols-none pad:gap-0 pad:w-[45.9375rem] lg:w-[51.5625rem] pad:flex pad:absolute pad:left-1/2 pad:-translate-x-1/2;
}

.home-content-btn {
    @apply xs:text-lg rounded-md bg-white text-black border border-gray-200 shadow-4 h-auto lg:hover:bg-primary lg:hover:border-gray-200 lg:hover:text-white p-0;
}

.modal-button {
    @apply fixed bottom-2.5 left-0 pad:left-[3.1875rem] bg-error w-[2.75rem] h-[2.75rem] flex justify-center items-center rounded-r pad:rounded cursor-pointer;
}

.btnArrow::after {
    @apply content-[''] block w-0 h-0 border-solid absolute left-1/2 bottom-0.5 translate-y-full -translate-x-1/2;
    border-width: 20px 16px 0 16px;
    border-color: #489abd transparent transparent transparent;
    filter: drop-shadow(0 2px 5px #0000001a);
}
</style>
